type WidgetEventName = 'widget_shown' | 'widget_nav';

const UI_CONTEXT = 'talviolympialaiset26';

/**
 * Sends an analytics event to the dataLayer if available.
 * Based on the Pakki implementation for consistency with HS Datadesk analytics patterns.
 */
export const sendAnalyticsEvent = (eventName: WidgetEventName, eventLabel?: string) => {
  if (!(window as any).dataLayer) {
    return;
  }

  // dataLayer persists values, so we explicitly clear label to avoid carrying over previous values
  (window as any).dataLayer.push({
    event: 'ui_event',
    event_name: eventName,
    ui_context: UI_CONTEXT,
    label: eventLabel || '',
  });
};

/**
 * Send widget_shown event when the widget is loaded/mounted
 */
export const trackWidgetShown = () => {
  sendAnalyticsEvent('widget_shown');
};

/**
 * Send widget_nav event when user interacts with navigation elements
 */
export const trackWidgetNav = (label: string) => {
  sendAnalyticsEvent('widget_nav', label);
};
